import type { TypedMyBrandHotel } from './-MyBrandHotel';
import RawMyBrandHotel from './MyBrandHotel.vue';
export * from './-MyBrandHotel';
export const MyBrandHotel = RawMyBrandHotel as typeof TypedMyBrandHotel;
